module.exports = __webpack_public_path__ + "static/media/youtube-music.08f6a5ef.png";